import React, { useState } from "react";
import {NavLink, useLocation} from "react-router-dom";
import { FiX } from 'react-icons/fi';
import classnames from 'classnames';

import bugger from '../../assets/images/bugger.svg';

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const {pathname} = useLocation();

  return (
    <nav className="navbar"> 
      <div onClick={() => setOpen(!open)} className="nav-icon">
        {open ? <FiX /> : <img src={bugger} alt="hamburger"/>}
      </div>
        <ul className={open ? 'nav-links active' : 'nav-links'}>
          <li className="nav-item">
            <a 
              href="/"
              className={classnames(
                {
                  'nav-active': pathname === '/',
                  'nav-link': pathname !== '/',
                }
              )}  
            >
              Home
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="/who-we-are"
              className={classnames(
                {
                  'nav-active': pathname === '/who-we-are',
                  'nav-link': pathname !== '/who-we-are',
                }
              )}  
            >
              Who We Are
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="/nft-utilities"
              className={classnames(
                {
                  'nav-active': pathname === '/nft-utilities',
                  'nav-link': pathname !== '/nft-utilities',
                }
              )}  
            >
              NFT & Utilites
            </a>
          </li>
          <li className="nav-item">
            <a 
              href="https://ticket.metafans.com"
              className={classnames(
                {
                  'nav-active': pathname === '/tickets',
                  'nav-link': pathname !== '/tickets',
                }
              )}  
            >
              Tickets
            </a>
          </li>
        </ul>
    </nav>
  );
};

export default Navbar;